var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNovaChainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 60,
    viewBox: "0 0 210 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lux-blue",
    x1: 0,
    y1: 0,
    x2: 210,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0096ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1f2fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd700"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lux-shadow",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 2,
    floodColor: "#0fc3ff",
    floodOpacity: 0.23
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 3,
    floodColor: "#021b2d",
    floodOpacity: 0.23
  })))), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 45,
    fontFamily: "'Montserrat', 'Inter', 'Segoe UI', Arial, Helvetica, sans-serif",
    fontSize: 43,
    fontWeight: 900,
    fill: "url(#lux-blue)",
    filter: "url(#lux-shadow)",
    letterSpacing: -2,
    style: {
      fontVariantLigatures: "none",
      paintOrder: "stroke"
    }
  }, "Novachain"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaChainLogo);
export default __webpack_public_path__ + "static/media/NovaChainLogo.c45c58d0429c1f60c37ba10d1e65fa43.svg";
export { ForwardRef as ReactComponent };